import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  initializeAuth,
  getAuth,
  browserLocalPersistence,
  type Auth,
} from 'firebase/auth';
import { configs } from "@/configs";

const firebaseConfig = configs.firebase;
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
let _auth: Auth;

if (typeof window === 'undefined') {
  _auth = getAuth(app);
} else {
  _auth = initializeAuth(app, {
    persistence:  browserLocalPersistence,
  });
}

export const auth = _auth;
